import type { ThemeOptions, AlertColor } from '@mui/material';

declare module '@mui/material/Alert' {
  interface AlertPropsVariantOverrides {
    snackbar: true;
  }
  interface AlertPropsColorOverrides {
    primary: true;
  }
}

const AlertTheme: ThemeOptions['components'] = {
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        padding: '21px 24px 21px 24px',
        width: '100%',
      },
      message: {
        padding: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
      },
    },
    variants: [
      {
        props: { severity: 'info' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.info.light,
          color: contextTheme.palette.info.dark,
        }),
      },
      {
        props: { severity: 'error' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.error.light,
          color: contextTheme.palette.error.dark,
        }),
      },
      {
        props: { severity: 'warning' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.warning.light,
          color: contextTheme.palette.secondary.dark,
        }),
      },

      {
        props: { variant: 'snackbar' },
        style: ({ theme: contextTheme }) => ({
          width: '100%',
          padding: '8px 16px 8px 16px',
          backgroundColor: contextTheme.palette.primary.dark,
          color: contextTheme.palette.primary.contrastText,
        }),
      },
      {
        props: { variant: 'snackbar', color: 'info' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.info.main,
          color: contextTheme.palette.info.contrastText,
        }),
      },
      {
        props: { variant: 'snackbar', color: 'error' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.error.main,
          color: contextTheme.palette.error.contrastText,
        }),
      },
      {
        props: { variant: 'snackbar', color: 'primary' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.primary.main,
          color: contextTheme.palette.primary.contrastText,
        }),
      },
      {
        props: { variant: 'snackbar', color: 'warning' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.warning.main,
          color: contextTheme.palette.warning.contrastText,
        }),
      },
      {
        props: { variant: 'snackbar', color: 'success' },
        style: ({ theme: contextTheme }) => ({
          backgroundColor: contextTheme.palette.success.main,
          color: contextTheme.palette.success.contrastText,
        }),
      },
    ],
  },
};

export default AlertTheme;
